export enum DataTypeEnum {
    Checkbox = "Checkbox",
    ActorAction = "ActorAction",
    DateTime = "DateTime",
    DocumentType = "DocumentType",
    General = "General",
    FileSize = "FileSize",
    RequestType = "RequestType",
    Status = "Status",
    Guid = "Guid",
    Stage = "Stage",
    Hash = "Hash",
    WorkgroupName = "WorkgroupName",
    Workflow = "Workflow",

    YesNo = "YesorNoBoolean",

    // Specific for sendgroups
    SendDate = "SendDate",
    PlusDays = "PlusDays",
    CompletionDate = "CompletionDate",
    /**
     * Specific field to display auto export status (and if it is enabled0)
     */
    AutoExportStatus = "AutoExportStatus",
}